import { ref } from 'vue';
import { defineStore } from 'pinia';
import { autoAuctionApiSdk, idOf, saleAssetOf } from '@hds/auto-auction-com-client-sdk';

// What the clerk's lane is selling, read from vibe-server: the sale, which is
// one lane and carries the run order, and its assets in that order. A sale's id
// is the runtime's event id, so the console opens a sale by the event it drives.
export const useSaleAndAssetsStore = defineStore('saleAndAssetsStore', () => {
    const sales = ref({});
    const assets = ref({});

    async function loadSaleAndAssets(saleId) {
        const [allSales, saleAssets] = await Promise.all([
            autoAuctionApiSdk.getSales(),
            autoAuctionApiSdk.getSaleAssets(saleId)
        ]);
        const sale = allSales.find((candidate) => idOf(candidate) === saleId);
        if (sale) {
            sales.value[saleId] = sale;
        }
        saleAssets.map(saleAssetOf).forEach((asset) => {
            assets.value[asset.id] = asset;
        });
    }

    return {
        sales,
        assets,
        loadSaleAndAssets
    };
});
